import { render, staticRenderFns } from "./MenuForClient.vue?vue&type=template&id=3e3b3de8&scoped=true&"
import script from "./MenuForClient.vue?vue&type=script&lang=ts&"
export * from "./MenuForClient.vue?vue&type=script&lang=ts&"
import style0 from "./MenuForClient.vue?vue&type=style&index=0&id=3e3b3de8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3b3de8",
  null
  
)

export default component.exports